import { GET, POST } from "config/api.config";
import { ABOUT_US, FACILITY, HOMEPAGE, USER } from "config/apiEndPoint";
import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';

export const fetchCandidateDetails = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_DETAILS}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateAcceptRoadTest = async (data = array()) => {
    try {
        let url = `${USER.ACCEPT_ROAD_TEST_ACCEPTED}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateRejectRoadTest = async (data = array()) => {
    try {
        let url = `${USER.ACCEPT_ROAD_TEST_REJECTED}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateConversastionSubmit = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_CONVERSATION_SUBMIT}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateInterested = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_INTERESTED}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateNotInterested = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_NOT_INTERESTED}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const requestACallBack = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_CALLBACK}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const requestACancelCallBack = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_CANCELLED_CALLBACK}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateUpdateProfileData = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_UPDATE_PROFILE_DATA}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateUpdateDocumentsData = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_UPDATE_DOCUMENTS_DATA}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateUpdateExperienceData = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_UPDATE_EXPERIENCE_DATA}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const handleDeleteExperience = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_DELETE_EXPERIENCE_DATA}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateOnboardingDoucmentsList = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_ONBOARDING_DOCUMENTS_LIST}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateUpdateCitigen = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_UPDATE_CITIGEN}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

export const candidateOnboardingDocumentUpload = async (data = array()) => {
    try {
        let url = `${USER.CANDIDATE_ONBOARDING_DOCUMENT_UPLOAD}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(error);
        // console.log(error);
    }
};

